'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var core = require('@material-ui/core');
var getThemeProp = require('../utils/getThemeProp.js');

var Label = styled__default.p(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  font-family: ", ";\n  font-size: 14px;\n  color: ", ";\n  margin-bottom: 0.2rem;\n  margin-top: 0;\n"], ["\n  font-family: ", ";\n  font-size: 14px;\n  color: ", ";\n  margin-bottom: 0.2rem;\n  margin-top: 0;\n"])), getThemeProp('typography.fontFamily', 'sans-serif'), getThemeProp('palette.text.secondary', 'grey'));
var DashedDivider = styled__default(core.Divider)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  height: 0;\n  border-top: 1px dashed ", ";\n  background-color: initial;\n  margin-bottom: 0.5rem;\n"], ["\n  height: 0;\n  border-top: 1px dashed ", ";\n  background-color: initial;\n  margin-bottom: 0.5rem;\n"])), getThemeProp('palette.divider'));
var templateObject_1, templateObject_2;

exports.DashedDivider = DashedDivider;
exports.Label = Label;
